import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { axiosClientSignIn } from '../axios/api.js'

// Fetch tasks assigned to the logged-in user
export const fetchMyTasks = createAsyncThunk("tasks/fetchMyTasks", async (_, { rejectWithValue }) => {
  try {
    const response = await axiosClientSignIn.get("/tasks/getmytask");
    if (response.data.message === "Super Admins cannot have assigned tasks.") {
      return rejectWithValue("Super Admins cannot have assigned tasks.");
    }
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response?.data?.message || "Failed to load tasks.");
  }
});

export const fetchOneTask = createAsyncThunk("tasks/fetchOnetask/:taskId", async (_, { rejectWithValue }) => {
  try {
    const response = await axiosClientSignIn.get("/tasks/fetchOnetask/:taskId");
    if (response.data.message === "Super Admins cannot have assigned tasks.") {
      return rejectWithValue("Super Admins cannot have assigned tasks.");
    }
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response?.data?.message || "Failed to load tasks.");
  }
});

// NEW: Request completion by assignee
// In your Redux slice
export const fetchCompletionRequestsByTask = createAsyncThunk(
  "tasks/fetchCompletionRequests",
  async (taskId, { rejectWithValue }) => {
    try {
      const response = await axiosClientSignIn.get(`/tasks/${taskId}/completion-requests`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Failed to fetch completion requests");
    }
  }
);
// NEW: Request Completion by assignee
export const requestCompletion = createAsyncThunk(
  "tasks/requestCompletion",
  async ({ taskId, remark }, { rejectWithValue, dispatch }) => {
    try {
      const response = await axiosClientSignIn.patch(`/tasks/${taskId}/request-completion`, {
        remark
      });

      // Refetch tasks to get fresh data
      await dispatch(TaskDisscutionManagerdata());
      // await dispatch(fetchTaskById(taskId));

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Failed to request completion");
    }
  }
);

// NEW: Verify Completion by assigner
export const verifyCompletion = createAsyncThunk(
  "tasks/verifyCompletion",
  async ({ taskId, action, remark }, { rejectWithValue, dispatch }) => {
    try {
      const response = await axiosClientSignIn.patch(`/tasks/${taskId}/verify-completion`, {
        action,
        remark
      });

      // Refetch tasks to get fresh data
      await dispatch(TaskDisscutionManagerdata());
      // await dispatch(fetchTaskById(taskId));

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Failed to verify completion");
    }
  }
);

// NEW: Bulk request completion by assignee (select several tasks, submit them all at once)
export const bulkRequestCompletion = createAsyncThunk(
  "tasks/bulkRequestCompletion",
  async ({ taskIds, remark }, { rejectWithValue, dispatch }) => {
    try {
      const response = await axiosClientSignIn.post(`/tasks/bulk-request-completion`, {
        taskIds,
        remark
      });

      await dispatch(TaskDisscutionManagerdata());

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Failed to submit bulk completion requests");
    }
  }
);

// NEW: Bulk verify (approve/reject) completion requests by assigner
export const bulkVerifyCompletion = createAsyncThunk(
  "tasks/bulkVerifyCompletion",
  async ({ taskIds, action, remark }, { rejectWithValue, dispatch }) => {
    try {
      const response = await axiosClientSignIn.patch(`/tasks/bulk-verify-completion`, {
        taskIds,
        action,
        remark
      });

      await dispatch(TaskDisscutionManagerdata());

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Failed to submit bulk verification");
    }
  }
);

// NEW: Fetch all completion requests (history) for a task
export const fetchCompletionRequests = createAsyncThunk(
  "tasks/fetchCompletionRequests",
  async (taskId, { rejectWithValue }) => {
    try {
      const response = await axiosClientSignIn.get(`/tasks/${taskId}/pending-requests`);
      return response.data.requests || [];
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Failed to fetch requests");
    }
  }
);

// NEW: Fetch all pending completion requests for the assigner
export const fetchPendingCompletionRequests = createAsyncThunk(
  "tasks/fetchPendingCompletionRequests",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosClientSignIn.get("/tasks/pending-completion-requests");
      return response.data.pendingCompletions || [];
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Failed to fetch pending requests");
    }
  }
);

// NEW: Fetch all completion requests raised BY the current user
export const fetchMyRaisedRequests = createAsyncThunk(
  "tasks/fetchMyRaisedRequests",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosClientSignIn.get("/tasks/my-raised-requests");
      return response.data.requests || [];
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Failed to fetch your requests");
    }
  }
);

// Fetch tasks assigned to a specific user (e.g., for managers assigning tasks)
export const fetchTasks = createAsyncThunk("tasks/fetchTasks", async (userId, { rejectWithValue }) => {
  try {
    const response = await axiosClientSignIn.get(`/tasks/assigned-to/${userId}`);
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response?.data?.message || "Error fetching tasks.");
  }
});

export const fetchTasksAssignedByUser = createAsyncThunk("/task/getAllTask", async ({ rejectWithValue }) => {
  try {
    const response = await axiosClientSignIn.get('/tasks/getmytask');
    console.log(response.data)
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response?.data?.message || "Error fetching tasks.");
  }
});

export const assignTask = createAsyncThunk(
  "tasks/assignTask",
  async (taskData, { rejectWithValue }) => {
    try {
      const formDataToSend = new FormData();

      console.log("=== Starting assignTask ===");
      console.log("Original taskData:", taskData);
      console.log("Attachments in taskData:", taskData.attachments);
      console.log("Number of attachments:", taskData.attachments?.length || 0);
      console.log(taskData, "taskDatataskDatataskDatataskDatataskDatataskDatataskData")

      // Add all fields including attachments
      Object.keys(taskData).forEach(key => {
        const value = taskData[key];
        console.log(`Processing key: ${key}, value:`, value);

        if (key === 'attachments') {
          console.log("Processing attachments array...");
          if (value && value.length > 0) {
            value.forEach((file, index) => {
              console.log(`Appending file ${index}:`, file.name, file.size, file.type);
              formDataToSend.append('attachments', file);
            });
          } else {
            console.log("No attachments found or empty array");
          }
        }
        else if (key === 'subtasks') {
          console.log("Stringifying subtasks array...");
          formDataToSend.append(key, JSON.stringify(value));
        }
        else if (Array.isArray(value) || typeof value === "object") {
          formDataToSend.append(key, value);
        }
        else if (value !== null && value !== undefined) {
          console.log(`Appending ${key}:`, value);
          formDataToSend.append(key, value);
        } else {
          console.log(`Skipping ${key}: null or undefined`);
        }
      });

      // Log FormData contents (for debugging)
      for (let pair of formDataToSend.entries()) {
        if (pair[1] instanceof File) {
          console.log(`  ${pair[0]}: [File] ${pair[1].name} (${pair[1].size} bytes)`);
        } else {
          console.log(`  ${pair[0]}: ${pair[1]}`);
        }
      }

      console.log("Sending POST request to /tasks/assign...");
      const response = await axiosClientSignIn.post("tasks/assign", formDataToSend, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });

      console.log("Response received:", response.data);
      return response.data;

    } catch (error) {
      console.error("Error in assignTask thunk:", error);
      console.error("Error response:", error.response?.data);
      return rejectWithValue(error.response?.data?.message || "Failed to assign task.");
    }
  }
);

export const TaskDisscutionManagerdata = createAsyncThunk(
  "tasks/user/all-tasks",
  async (_, { rejectWithValue }) => {
    console.log("TaskDisscutionManagerdata");
    try {
      const response = await axiosClientSignIn.get("/tasks/taskdissutionmanger/user/all-tasks");
      console.log(response.data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Failed to fetch tasks.");
    }
  }
);

// New V2 Thunk for filtered/searched data
export const fetchTasksV2 = createAsyncThunk(
  "tasks/v2/fetch",
  async ({ tab, filter, search, from, to, priority, status }, { rejectWithValue }) => {
    try {
      let endpoint = "";
      if (search) {
        endpoint = "/tasks/v2/search";
      } else if (tab === "assignedToMe") {
        endpoint = "/tasks/v2/assigned-to-me";
      } else if (tab === "followups") {
        endpoint = "/tasks/v2/follow-ups";
      } else if (tab === "templates") {
        endpoint = "/tasks/templates/all";
      } else {
        endpoint = "/tasks/v2/assigned-by-me";
      }

      const response = await axiosClientSignIn.get(endpoint, {
        params: { filter, query: search, from, to, priority, status }
      });

      const data = response.data.tasks !== undefined ? response.data.tasks : (Array.isArray(response.data) ? response.data : []);

      return {
        tab,
        filter,
        search,
        tasks: data
      };
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Failed to fetch filtered tasks.");
    }
  }
);

export const deleteTemplate = createAsyncThunk(
  "tasks/templates/delete",
  async (templateId, { rejectWithValue }) => {
    try {
      await axiosClientSignIn.delete(`/tasks/templates/${templateId}`);
      return templateId;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Failed to delete template.");
    }
  }
);

export const updateTemplate = createAsyncThunk(
  "tasks/templates/update",
  async ({ templateId, templateData }, { rejectWithValue }) => {
    try {
      const response = await axiosClientSignIn.put(`/tasks/templates/${templateId}`, templateData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Failed to update template.");
    }
  }
);

export const createTemplate = createAsyncThunk(
  "tasks/templates/create",
  async (templateData, { rejectWithValue }) => {
    try {
      const response = await axiosClientSignIn.post("/tasks/templates", templateData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Failed to create template.");
    }
  }
);

export const fetchTaskCountsV2 = createAsyncThunk(
  "tasks/v2/counts",
  async (params = {}, { rejectWithValue }) => {
    const { search, from, to, priority, status } = params;
    try {
      const response = await axiosClientSignIn.get("/tasks/v2/counts", {
        params: { query: search, from, to, priority, status }
      });
      return response.data.counts || {};
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Failed to fetch task counts.");
    }
  }
);

// Personal task statistics — "where am I lagging?" (delays, late submissions, approval waits)
export const fetchMyTaskStats = createAsyncThunk(
  "tasks/stats/my",
  async (userId, { rejectWithValue }) => {
    try {
      const url = userId ? `/tasks/stats/user/${userId}` : "/tasks/stats/my";
      const response = await axiosClientSignIn.get(url);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Failed to fetch task statistics.");
    }
  }
);

export const updateTask = createAsyncThunk(
  "tasks/user/update",
  async (data, { rejectWithValue }) => {
    console.log("update task", data);
    try {
      const response = await axiosClientSignIn.put(`/tasks/update-status/${data.id}`, {
        data
      });
      console.log(response, "response data");
      return response.data;
    } catch (error) {
      console.log(error);
      return rejectWithValue(error.response?.data?.message || "Failed to update task.");
    }
  }
);

export const editTask = createAsyncThunk(
  "tasks/editTask",
  async ({ taskId, updatedData }, { rejectWithValue, dispatch }) => {
    try {
      const response = await axiosClientSignIn.put(`/tasks/edit/task/${taskId}`, updatedData);
      await dispatch(TaskDisscutionManagerdata());
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Failed to edit task.");
    }
  }
);


export const requestDueDateExtension = createAsyncThunk(
  "tasks/requestDueDateExtension",
  async ({ taskId, dueDateRequest }, { rejectWithValue }) => {
    try {
      const response = await axiosClientSignIn.post(`/tasks/${taskId}/request-extension`, {
        dueDateRequest,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Failed to request extension");
    }
  }
);

export const approveDueDateExtension = createAsyncThunk(
  "tasks/approveDueDateExtension",
  async ({ taskId, status }, { rejectWithValue }) => {
    try {
      const response = await axiosClientSignIn.patch(`/tasks/${taskId}/approve-extension`, {
        status,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Failed to approve/reject extension");
    }
  }
);

export const submitTaskProgress = createAsyncThunk(
  "tasks/submitTaskProgress",
  async ({ taskId, status, remark }, { rejectWithValue }) => {
    try {
      const response = await axiosClientSignIn.post(`/tasks/${taskId}/submit-progress`, {
        status,
        remark,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Failed to submit progress");
    }
  }
);

export const updateTaskByAssigner = createAsyncThunk(
  'tasks/updateTaskByAssigner',
  async ({ taskId, updates }, { rejectWithValue }) => {
    try {
      const response = await axiosClientSignIn.put(`/tasks/update-by-assigner/${taskId}`, updates);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Update failed');
    }
  }
);

export const escalateTask = createAsyncThunk(
  "tasks/escalateTask",
  async (taskId, { rejectWithValue }) => {
    console.log("escaletd task tasj")
    try {
      const response = await axiosClientSignIn.put(`/tasks/${taskId}/escalate`, {
        reason: "Manually escalated by assigner",
      });
      return response.data.task;
    } catch (error) {
      console.log(error)
      return rejectWithValue(error.response?.data?.message || "Escalation failed");
    }
  }
);

export const logEffortToTask = createAsyncThunk(
  "task/logEffort",
  async ({ taskId, hoursSpent, description }, thunkAPI) => {
    try {
      const response = await axiosClientSignIn.post(`/tasks/${taskId}/effort-log`, {
        hoursSpent,
        description,
      });
      return response.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data?.message || "Failed to log effort");
    }
  }
);

export const handleDueDateRequestApproveRejection = createAsyncThunk("task/hamdleduedateRequest",
  async ({ taskId, requestId, decision }, thunkAPI) => {
    const response = await axiosClientSignIn.post(`/tasks/handleDueDateRequestApproveRejection/${taskId}`, {
      requestId,
      decision
    });
    console.log("datauderequest")
    console.log("resposness")
    return response.data.requests;
  }
)

export const fetchDueDateRequests = createAsyncThunk(
  "dueDateRequest/fetchByTaskId",
  async (taskId, thunkAPI) => {
    const response = await axiosClientSignIn.get(`tasks/due-date-requests/${taskId}`);
    console.log("datauderequest")
    console.log(response.data.requests)
    return response.data.requests;
  }
);

export const addTaskRemark = createAsyncThunk(
  "task/addTaskRemark",
  async ({ taskId, text }, { rejectWithValue }) => {
    try {
      const res = await axiosClientSignIn.post(`/tasks/${taskId}/remarks`, { text });
      return { taskId, remark: res.data.remark };
    } catch (err) {
      console.log(err)
      return rejectWithValue(err.response?.data?.message || "Error adding remark");
    }
  }
);

export const fetchTaskById = createAsyncThunk(
  "task/fetchById",
  async (taskId, { rejectWithValue }) => {
    try {
      const response = await axiosClientSignIn.get(`/tasks/fetchById/${taskId}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Task not found");
    }
  }
);

export const discardTask = createAsyncThunk(
  "task/discard",
  async (taskId) => {
    const response = await axiosClientSignIn.delete(`/tasks/${taskId}/delete`);
    console.log(response)
    if (!response.status === 200) throw new Error("Task  is deleted");
    const data = await response.data
    return data;
  }
);

export const recallTask = createAsyncThunk(
  "task/recall",
  async (taskId, { rejectWithValue }) => {
    try {
      const response = await axiosClientSignIn.post(`/tasks/${taskId}/recall`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Failed to send recall email.");
    }
  }
);

export const sendFileMessage = createAsyncThunk(
  'task/sendFileMessage',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await axiosClientSignIn.post('/chat/disscutionmessages/file', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const fetchTaskSchedules = createAsyncThunk(
  "tasks/fetchTaskSchedules",
  async (templateId, { rejectWithValue }) => {
    try {
      const response = await axiosClientSignIn.get(`/tasks/templates/${templateId}/schedule`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Failed to fetch schedules");
    }
  }
);

export const forceGenerateMissedTask = createAsyncThunk(
  "tasks/forceGenerateMissedTask",
  async (scheduleId, { rejectWithValue }) => {
    try {
      const response = await axiosClientSignIn.post(`/tasks/schedule/${scheduleId}/generate`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Failed to generate task");
    }
  }
);

const taskSlice = createSlice({
  name: "tasks",
  initialState: {
    selectedTask: null,
    tasks: [],
    assignTaskBy: [],
    TaskDisscutionManager: [],
    assignedToMe: [],
    followUpTasks: [],
    archivedTasks: [],
    taskTemplates: [],
    taskCountsByTab: {
      assignedToMe: { total: 0, overdue: 0, archived: 0 },
      assignedByMe: { total: 0, overdue: 0, archived: 0 },
      followups: { total: 0, overdue: 0, archived: 0 }
    },
    taskCountsLoading: false,
    myTaskStats: null,
    myTaskStatsLoading: false,
    requests: [],
    pendingCompletions: [],
    completionRequests: [], // History for selected task
    myRaisedRequests: [], // Requests raised BY current user
    loading: false,
    loadingselected: false,
    error: null,
  },
  reducers: {
    setTasks: (state, action) => {
      state.tasks = action.payload;
    },
    setSelectedTask: (state, action) => {
      state.selectedTask = action.payload;
    },
    clearSelectedTask: (state) => {
      state.selectedTask = null;
    },
    clearArchivedTasks: (state) => {
      state.archivedTasks = [];
    },
    updateTaskStatus: (state, action) => {
      const { taskId, newStatus } = action.payload;
      const task = state.tasks.find((task) => task._id === taskId);
      if (task) {
        task.status = newStatus;
      }
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch My Tasks
      .addCase(fetchMyTasks.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchMyTasks.fulfilled, (state, action) => {
        state.loading = false;
        state.tasks = action.payload;
      })
      .addCase(fetchMyTasks.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // NEW: Request Completion
      .addCase(requestCompletion.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(requestCompletion.fulfilled, (state, action) => {
        state.loading = false;
        const updatedTask = action.payload.task;
        // if (updatedTask) {
        //   const index = state.tasks.findIndex(task => task._id === updatedTask._id);
        //   if (index !== -1) state.tasks[index] = updatedTask;
        //   if (state.selectedTask?._id === updatedTask._id) state.selectedTask = updatedTask;
        // }
      })
      .addCase(requestCompletion.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // NEW: Verify Completion
      .addCase(verifyCompletion.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(verifyCompletion.fulfilled, (state, action) => {
        state.loading = false;
        const updatedTask = action.payload.task;
        // if (updatedTask) {
        //   const index = state.tasks.findIndex(task => task._id === updatedTask._id);
        //   if (index !== -1) state.tasks[index] = updatedTask;
        //   if (state.selectedTask?._id === updatedTask._id) state.selectedTask = updatedTask;
        // }
      })
      .addCase(verifyCompletion.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // NEW: Bulk Request Completion
      .addCase(bulkRequestCompletion.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(bulkRequestCompletion.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(bulkRequestCompletion.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // NEW: Bulk Verify Completion
      .addCase(bulkVerifyCompletion.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(bulkVerifyCompletion.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(bulkVerifyCompletion.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(fetchPendingCompletionRequests.fulfilled, (state, action) => {
        state.pendingCompletions = action.payload;
      })

      .addCase(fetchCompletionRequests.fulfilled, (state, action) => {
        state.completionRequests = action.payload;
      })

      .addCase(fetchMyRaisedRequests.fulfilled, (state, action) => {
        state.myRaisedRequests = action.payload;
      })

      .addCase(fetchTaskById.pending, (state) => {
        state.loadingselected = true;
        state.error = null;
      })
      .addCase(fetchTaskById.fulfilled, (state, action) => {
        state.loadingselected = false;
        state.selectedTask = action.payload;
      })
      .addCase(fetchTaskById.rejected, (state, action) => {
        state.loadingselected = false;
        state.error = action.error.message;
      })

      .addCase(updateTask.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateTask.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
        const updatedTask = action.payload;
        const index = state.tasks.findIndex(task => task._id === updatedTask._id);
        if (index !== -1) {
          state.tasks[index] = updatedTask;
        }
      })
      .addCase(updateTask.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Something went wrong";
      })

      .addCase(editTask.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(editTask.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
        const updatedTask = action.payload;
        if (state.selectedTask && state.selectedTask._id === updatedTask._id) {
          state.selectedTask = { ...state.selectedTask, ...updatedTask };
        }
        const index = state.tasks.findIndex(task => task._id === updatedTask._id);
        if (index !== -1) {
          state.tasks[index] = { ...state.tasks[index], ...updatedTask };
        }
      })
      .addCase(editTask.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Something went wrong";
      })

      .addCase(fetchTasksAssignedByUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTasksAssignedByUser.fulfilled, (state, action) => {
        state.loading = false;
        state.assignTaskBy = action.payload;
      })
      .addCase(fetchTasksAssignedByUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Something went wrong";
      })

      .addCase(TaskDisscutionManagerdata.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(TaskDisscutionManagerdata.fulfilled, (state, action) => {
        state.loading = false;
        console.log("redux ----------------------------------------------------------------------------------------------------->")
        console.log(action.payload.assignedByMe)
        console.log(action.payload.assignedToMe)

        const assignedToMe = action.payload.assignedToMe || [];
        const rawFollowUps = action.payload.followUpTasks || action.payload.followUpOnly || [];

        const followUpTasks = [];
        const followUpIds = new Set();
        rawFollowUps.forEach((task) => {
          const id = task?._id?.toString();
          if (id && !followUpIds.has(id)) {
            followUpIds.add(id);
            followUpTasks.push(task);
          }
        });

        const rawAssignedByMe = action.payload.assignedByMe || [];
        const assignedByMe = rawAssignedByMe.filter((task) => {
          const id = task?._id?.toString();
          return !id || !followUpIds.has(id);
        });

        state.assignedToMe = assignedToMe;
        state.assignTaskBy = assignedByMe;
        state.followUpTasks = followUpTasks;
      })
      .addCase(TaskDisscutionManagerdata.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Something went wrong";
      })

      .addCase(fetchTasksV2.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTasksV2.fulfilled, (state, action) => {
        state.loading = false;
        const { tab, filter, tasks } = action.payload;

        if (filter === "Archived") {
          // Merge into archivedTasks and deduplicate by _id
          const existing = state.archivedTasks.filter(
            t => !tasks.some(n => String(n._id) === String(t._id))
          );
          state.archivedTasks = [...existing, ...tasks].sort(
            (a, b) => new Date(b.isCompleted || b.updatedAt) - new Date(a.isCompleted || a.updatedAt)
          );
        } else if (tab === "assignedToMe") {
          state.assignedToMe = tasks;
        } else if (tab === "assignedByMe") {
          state.assignTaskBy = tasks;
        } else if (tab === "followups") {
          state.followUpTasks = tasks;
        } else if (tab === "templates") {
          state.taskTemplates = tasks;
        }
      })
      .addCase(fetchTasksV2.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Something went wrong";
      })
      .addCase(deleteTemplate.fulfilled, (state, action) => {
        state.taskTemplates = state.taskTemplates.filter(t => t._id !== action.payload);
      })
      .addCase(updateTemplate.fulfilled, (state, action) => {
        const updated = action.payload;
        const index = state.taskTemplates.findIndex(t => t._id === updated._id);
        if (index !== -1) {
          state.taskTemplates[index] = updated;
        }
      })
      .addCase(createTemplate.fulfilled, (state, action) => {
        state.taskTemplates.push(action.payload);
      })

      .addCase(fetchTaskCountsV2.pending, (state) => {
        state.taskCountsLoading = true;
      })
      .addCase(fetchTaskCountsV2.fulfilled, (state, action) => {
        state.taskCountsLoading = false;
        state.taskCountsByTab = {
          assignedToMe: action.payload.assignedToMe || { total: 0, overdue: 0, archived: 0 },
          assignedByMe: action.payload.assignedByMe || { total: 0, overdue: 0, archived: 0 },
          followups: action.payload.followups || { total: 0, overdue: 0, archived: 0 },
          verification: action.payload.verificationQuery || { total: 0, overdue: 0, archived: 0 },
          combinedArchived: action.payload.combinedArchived ?? 0,
        };
      })
      .addCase(fetchTaskCountsV2.rejected, (state, action) => {
        state.taskCountsLoading = false;
      })

      .addCase(fetchMyTaskStats.pending, (state) => {
        state.myTaskStatsLoading = true;
      })
      .addCase(fetchMyTaskStats.fulfilled, (state, action) => {
        state.myTaskStatsLoading = false;
        state.myTaskStats = action.payload;
      })
      .addCase(fetchMyTaskStats.rejected, (state) => {
        state.myTaskStatsLoading = false;
        state.myTaskStats = null;
      })

      .addCase(assignTask.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(assignTask.fulfilled, (state, action) => {
        state.loading = false;
        state.tasks.push(action.payload);
      })
      .addCase(assignTask.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(requestDueDateExtension.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(requestDueDateExtension.fulfilled, (state, action) => {
        state.loading = false;
        const updatedTask = action.payload;
        const index = state.tasks.findIndex(task => task._id === updatedTask._id);
        if (index !== -1) state.tasks[index] = updatedTask;
      })
      .addCase(requestDueDateExtension.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(approveDueDateExtension.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(approveDueDateExtension.fulfilled, (state, action) => {
        state.loading = false;
        const updatedTask = action.payload;
        const index = state.tasks.findIndex(task => task._id === updatedTask._id);
        if (index !== -1) state.tasks[index] = updatedTask;
      })
      .addCase(approveDueDateExtension.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(submitTaskProgress.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(submitTaskProgress.fulfilled, (state, action) => {
        state.loading = false;
        const updatedTask = action.payload;
        const index = state.tasks.findIndex(task => task._id === updatedTask._id);
        if (index !== -1) state.tasks[index] = updatedTask;
      })
      .addCase(submitTaskProgress.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(updateTaskByAssigner.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateTaskByAssigner.fulfilled, (state, action) => {
        state.loading = false;
        const updatedTask = action.payload;
        const index = state.tasks.findIndex(task => task._id === updatedTask._id);
        if (index !== -1) {
          state.tasks[index] = updatedTask;
        }
      })
      .addCase(updateTaskByAssigner.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(escalateTask.fulfilled, (state, action) => {
        const updated = action.payload;
        const index = state.tasks.findIndex(t => t._id === updated._id);
        if (index !== -1) state.tasks[index] = updated;
      })

      .addCase(fetchDueDateRequests.pending, (state) => {
        state.error = null;
      })
      .addCase(fetchDueDateRequests.fulfilled, (state, action) => {
        state.requests = action.payload;
      })
      .addCase(fetchDueDateRequests.rejected, (state, action) => {
        state.error = action.error.message;
      })

      .addCase(sendFileMessage.pending, (state) => {
        state.error = null;
      })
      .addCase(sendFileMessage.fulfilled, (state, action) => {
        // state.requests = action.payload;
      })
      .addCase(sendFileMessage.rejected, (state, action) => {
        state.error = action.error.message;
      });
  }
});

export const { updateTaskStatus, setTasks, setSelectedTask, clearSelectedTask, clearArchivedTasks } = taskSlice.actions;
export default taskSlice.reducer;